import React from 'react';
import styled from 'styled-components/macro';
import Modal from '../../../components/Modal';
import { Button, ButtonGroup } from '../../../components/Buttons';
import { WithTranslation, withTranslation } from 'react-i18next';
import { H2, P } from '../../../components/Typography';
import { distances, colors, border } from '../../../styles/constants';
import Hr from '../../../components/Hr';

interface DeleteCustomerModalProps extends WithTranslation {
    accountId: string;
    customerId: string;
    closeModal: () => void;
    deleteCustomer: (accountId: string, customerId: string) => void;
}

const DeleteCustomerModal = (
    {
        accountId,
        customerId,
        closeModal,
        deleteCustomer,
        t,
    }: DeleteCustomerModalProps
) => {
    return (
        <Modal>
            <H2>{t('customers.customer.delete_customer.title')}</H2>
            <P>{t('customers.customer.delete_customer.text')}</P>
            <Hr />
            <ButtonGroup>
                <Button onClick={() => deleteCustomer(accountId, customerId)}>
                    {t('customers.customer.delete_customer.confirm')}
                </Button>

                <Button className="alt" type="button" onClick={closeModal}>
                    {t('customers.customer.delete_customer.cancel')}
                </Button>
            </ButtonGroup>
        </Modal>
    );
};

export default withTranslation()(DeleteCustomerModal);
